import { type FC } from 'react';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import {
  BrightnessAutoOutlined,
  Check,
  DarkMode,
  LightMode,
} from '@mui/icons-material';

import {
  SelectDialog,
  type SelectDialogProps,
} from '#packages/web/foundations/feedback/select-dialog';

import { type ThemeAppearance } from '#apps/client-web/features/settings/models/app-settings';

export type SelectThemeAppearanceDialogProps = Pick<
  SelectDialogProps<ThemeAppearance>,
  'onFormCancel' | 'onFormSubmit' | 'open' | 'initialValue'
>;

export const SelectThemeAppearanceDialog: FC<
  SelectThemeAppearanceDialogProps
> = ({
  open,

  initialValue,

  onFormCancel,
  onFormSubmit,
}) => (
  <SelectDialog
    title="Select Appearance"
    open={open}
    initialValue={initialValue}
    onFormCancel={onFormCancel}
    onFormSubmit={onFormSubmit}>
    <List>
      <ListItemButton
        onClick={onFormSubmit.bind(undefined, 'system' as ThemeAppearance)}>
        <ListItemIcon>{initialValue === 'system' && <Check />}</ListItemIcon>
        <ListItemText
          primary={<Typography>System</Typography>}
          secondary="Use system settings"
        />
        <BrightnessAutoOutlined />
      </ListItemButton>
      <ListItemButton
        onClick={onFormSubmit.bind(undefined, 'light' as ThemeAppearance)}>
        <ListItemIcon>{initialValue === 'light' && <Check />}</ListItemIcon>
        <ListItemText
          primary={<Typography>Light</Typography>}
          secondary="Bright background and dark text"
        />
        <LightMode />
      </ListItemButton>
      <ListItemButton
        onClick={onFormSubmit.bind(undefined, 'dark' as ThemeAppearance)}>
        <ListItemIcon>{initialValue === 'dark' && <Check />}</ListItemIcon>
        <ListItemText
          primary={<Typography>Dark</Typography>}
          secondary="Dark background and light text"
        />
        <DarkMode />
      </ListItemButton>
    </List>
  </SelectDialog>
);
